import { INetworkUtilizationCardData } from '../../pages/UtilizationSummaryPage';

interface NetworkUtilizationResponse {
  totalPaid: number;
  providerType: string;
  networkIndicator: string;
}

export const formatNetworkUtilizationCardData = (
  responseData: NetworkUtilizationResponse[],
) => {
  const networkUtilizationCardData: INetworkUtilizationCardData = {
    facilityInNetwork: 0,
    facilityOutNetwork: 0,
    providerInNetwork: 0,
    providerOutNetwork: 0,
  };

  responseData?.forEach((item: NetworkUtilizationResponse) => {
    if (item.providerType === 'Facility') {
      if (item.networkIndicator === 'IN') {
        networkUtilizationCardData.facilityInNetwork = item.totalPaid;
      }
      if (item.networkIndicator === 'OUT') {
        networkUtilizationCardData.facilityOutNetwork = item.totalPaid;
      }
    }
    if (item.providerType === 'Physician') {
      if (item.networkIndicator === 'IN') {
        networkUtilizationCardData.providerInNetwork = item.totalPaid;
      }
      if (item.networkIndicator === 'OUT') {
        networkUtilizationCardData.providerOutNetwork = item.totalPaid;
      }
    }
  });
  return networkUtilizationCardData;
};
